/**
 * Basic image protection - deters casual copying, not a real barrier (a
 * determined visitor can still screenshot or use dev tools). Disables the
 * right-click context menu and native drag-to-save on <img> elements
 * site-wide, matching the same approach used on tuangcoffee.com.
 */
document.addEventListener('contextmenu', (event) => {
  if (event.target.closest('img')) event.preventDefault();
});
document.addEventListener('dragstart', (event) => {
  if (event.target.closest('img')) event.preventDefault();
});
